import { component as defineComponent } from 'flightjs';
import withDataAction from 'app/mixins/with-data-action';

function rating() {
    this.attributes({
        rating: '[data-star-rating]',
        stars: '[data-stars]',
    });

    this.saveRating = function (e, data) {
        this.submit(e, data, 'put').done(
            function (res) {
                this.trigger('dataEntryRated');
                this.trigger('dataEntryUpdated', res);
            }.bind(this)
        );
    };

    this.canRate = function () {
        return this.$node.data('editable');
    };

    this.rateEntry = function (e) {
        var targetValue = parseInt($(e.target).val(), 10);
        var componentValue = parseInt(this.$node.data('rate-value') || 0, 10);
        var isUnRating = targetValue === componentValue;
        var entryId = this.$node.data('entry-id');
        var ratingValue = isUnRating ? 0 : targetValue;

        if (this.canRate()) {
            if (isUnRating) {
                e.target.checked = false;
            }
            this.$node.data('rate-value', ratingValue);
            this.trigger('uiRateEntryRequested', {
                rating: ratingValue,
                entryId: entryId,
            });
        }
    };

    this.after('initialize', function () {
        if (this.canRate()) {
            this.on('click', {
                rating: this.rateEntry,
            });
        }

        this.on('uiRateEntryRequested', this.saveRating);
    });
}

export default defineComponent(rating, withDataAction);



// WEBPACK FOOTER //
// ./src/web/js/entry/ui/rating.js